/**
 * @ngdoc Service
 */
(function () {
    'use strict';

    angular.module('vrm.components')
        .service('VrmRequestCancellation', VrmRequestCancellation);


    /* @ngInject */
    function VrmRequestCancellation($rootScope, vrmConfig, $q, $state) {
        let cancellationTokens = {};
        let requests = []

        var service = {
            getRequestToken: getRequestToken,
            getRequestTokensStatsAndWidgets: getRequestTokensStatsAndWidgets,
            cancelAll: cancelAll
        };

        $rootScope.$on("$stateChangeStart", function (e, toState, toParams, fromState, fromParams) {
            cancelAll(fromState.name);
        })

        function getRequestToken(config) {
            // allow all requests to run when page is initialized
            // this prevents a bug where the state is not set before the requests are executed
            if ($state.current.name.length === 0) return;

            if (cancellationTokens[$state.current.name] === undefined) {
                cancellationTokens[$state.current.name] = $q.defer();
            }
            requests.push(config)
            return cancellationTokens[$state.current.name].promise;
        }


        function getRequestTokensStatsAndWidgets(config) {

            const api = vrmConfig.api

            let uri = config.url.replace(api, ''); // remove stem
            uri = uri.split('?')[0]; //  get rid of query args
            uri = uri.concat('/'); // make it unlikely to encounter it as a substring

            if (uri.includes('/stats/') || uri.includes('/widgets/') || uri.includes('/active-widgets/')) {
                return getRequestToken(config)
            }
        }

        function cancelAll(locationKey) {
            if (requests.length === 0 || !cancellationTokens[locationKey]) {
                return;
            }

            // Before cancelling all requests indicate they are manually cancelled
            requests.forEach(req => {
                req.isManualCancellation = true;
            })

            cancellationTokens[locationKey].resolve();

            requests = [];
            delete cancellationTokens[locationKey];
        }

        return service;
    }
})();
